export default class ErrorLogList {

	constructor (data) {
		this.data = data
	}

	static async fetch (machine_id = null) {
		if (machine_id) {
			const data = await Anvil.REST.get(`/c_order/terminal/${machine_id}/error_log`)
			return new ErrorLogList(data)
		} else {
			const data = await Anvil.REST.get('/c_order/error_log/list')
			return new ErrorLogList(data)
		}
	}
}
